export const PROFILE = [
  "Hey there! I'm Paargav, a Senior Software Engineer at Wells Fargo, building cool and resilient banking products.",
  "I love creating scalable full-stack and user-centric solutions that actually work (and don't break under pressure!). Recently, I’ve been geeking out on Generative AI and LLMs, exploring and experimenting to level up my skills.",
  "Coding, problem-solving, and making tech magic happen is my thing.",
  "This site? Just a little corner to show you what I'm all about!",
];